import React, {ForwardedRef, useImperativeHandle, useLayoutEffect, useRef} from "react";
import {Icon, Input} from "tea-component";

import {SearchWithTagsProps, TagType} from "@/pages/datalab/components/SearchWithTags/type";
import './index.scss';

const SearchWithTags = (props: SearchWithTagsProps, ref: ForwardedRef<HTMLDivElement>) => {
  const {
    tags=[], // 被选中的选项, 需要展示的tag
    searchWord,
    // maxCount=100, // 最多展示多少个tag, 剩下的展示数量tag, 为0的时候全部展示
    onDeleteTag, // tag上的删除按钮
    onSearch, // 点击搜索按钮
    onClearTags, // 清除所有tag和输入的搜索文字
    onSearchKeywordChange, // 搜索的值发生变化
    searchPlaceholder = '', // 搜索框占位符
  } = props;
  
  const wrapRef = useRef<HTMLDivElement>(null);
  
  // 默认滚动到底部搜索框显示
  useLayoutEffect(() => {
    wrapRef.current && (wrapRef.current.scrollTop = wrapRef.current.scrollHeight);
  }, [tags]);
  useImperativeHandle(ref, () => wrapRef.current!);
  
  
  return (
    <div className="dbl-region-select-search-container">
      <div className="dbl-region-select-search-wrap">
        <div className="dbl-region-select-search-input-wrap" ref={wrapRef}>
          <div
            className="dbl-region-select-search-input-wrap-inner"
          >
            {tags.map((item: TagType, index) => (
              <div
                className="tea-tag dbl-region-select-tag"
                key={item.value}
                title={item.title ?? item.text}
              >
                <span dangerouslySetInnerHTML={{__html: item.text}}></span>
                {item.disabled ? '' : (<Icon
                  onClick={() => {
                    onDeleteTag?.(item, index);
                  }}
                  type="close"
                />)}
              
              </div>
            ))}
            <Input
              placeholder={searchPlaceholder}
              value={searchWord}
              // ref={searchInputRef}
              className="dbl-region-select-search-input"
              type="text"
              onChange={onSearchKeywordChange}
              onPressEnter={onSearch}
              onMouseDown={(event) => event.stopPropagation()}
            />
          </div>
          <div className="dbl-region-select-search-icon">
            { searchWord ? (
              // 删除所有的Tag
              <Icon type="dismiss" onClick={() => {
                onSearchKeywordChange?.('');
                onClearTags?.();
              }} />
            ) : null}
            {/* <Icon type="search" onClick={() => {*/}
            {/*  // 搜索按钮*/}
            {/*  onSearch?.(searchWord ?? '');*/}
            {/* }}/>*/}
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default React.forwardRef(SearchWithTags);